import { ImmURL } from '$lib/utils/url/ImmURL';

export function getUtmVariablesFromUrl(url: URL | ImmURL) {
    let u = new ImmURL(url);

    return {
        utm_id: u.searchParams.get('utm_id'),
        utm_source: u.searchParams.get('utm_source'),
        utm_medium: u.searchParams.get('utm_medium'),
        utm_campaign: u.searchParams.get('utm_campaign'),
        utm_source_platform: u.searchParams.get('utm_source_platform'),
        utm_term: u.searchParams.get('utm_term'),
        utm_content: u.searchParams.get('utm_content'),
        utm_creative_format: u.searchParams.get('utm_creative_format'),
        utm_marketing_tactic: u.searchParams.get('utm_marketing_tactic'),
    } as const;
}
